import { demoFindingDetailsById } from './findingDetailsById';

/** 主展示漏洞详情（IDOR - Underwriter Claim Detail Access） */
export const demoFindingDetailFull =
  demoFindingDetailsById['ee75ada9-6b5e-4d14-bd90-823c5d23c53d'];
